import { useEffect } from "react";
import useRefreshToken from "./useRefreshToken";
import localStorageAvailable from './useLocalStorage';
import { axiosPrivateMultipart } from "../utils/axios";
import { setSession } from "../auth/utils";

const useAxiosPrivateMultiPart = () => {
    const refresh = useRefreshToken();
    const storageAvailable = localStorageAvailable();
    
    useEffect(() => {
        const accessToken = storageAvailable ? localStorage.getItem('accessToken') : '';

        const requestIntercept = axiosPrivateMultipart.interceptors.request.use(
            config => {
                if (!config.headers.Authorization) {
                    config.headers.Authorization = `Bearer ${accessToken}`;
                }
                return config;
            }, (error) => Promise.reject(error)
        );

        const responseIntercept = axiosPrivateMultipart.interceptors.response.use(
            response => response,
            async (error) => {
                const prevRequest = error?.config;
                if (error?.response?.status === 401 && !prevRequest?.sent) {
                    prevRequest.sent = true;
                    const newAccessToken = await refresh().catch((e) => {
                        setSession();
                        window.location.reload();
                    });
                    prevRequest.headers.Authorization = `Bearer ${newAccessToken}`;
                    return axiosPrivateMultipart(prevRequest);
                }
                return Promise.reject(error);
            }
        );

        return () => {
            axiosPrivateMultipart.interceptors.request.eject(requestIntercept);
            axiosPrivateMultipart.interceptors.response.eject(responseIntercept);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [refresh])

    return axiosPrivateMultipart;
}

export default useAxiosPrivateMultiPart;